module.exports = __webpack_public_path__ + "img/needle-left3.3a75b598.png";